// @ts-nocheck
import { PropsWithChildren } from 'react';

import '@material/web/radio/radio.js';
import { Typography } from '../typography/typography';
import styled from '@emotion/styled';

export interface RadioOption {
  value: string;
  content: string;
  checked?: boolean;
  dataCy?: string;
}

const StyledLabel = styled.label`
  display: flex;
  align-items: center;

  md-radio {
    flex-shrink: 0;
  }
`;

export interface RadioProps extends PropsWithChildren {
  disabled?: boolean;
  name?: string;
  option: RadioOption;
  onSelect?: (option: RadioOption) => void;
  checked?: boolean;
  'data-cy'?: string;
}

export const Radio = ({
  disabled = false,
  option,
  onSelect = (option: RadioOption) => {},
  checked = false,
  'data-cy': dataCy,
  ...otherProps
}: RadioProps) => {
  const props = {};
  if (disabled) {
    props.disabled = true;
  }
  if (name) {
    props.name = name;
  }

  if (checked) {
    props.checked = checked;
  }
  return (
    <StyledLabel data-cy={dataCy}>
      <md-radio
        touch-target="wrapper"
        {...props}
        {...otherProps}
        onClick={() => !disabled && onSelect(option)}
      ></md-radio>
      <Typography variant="textTitleSmall">{option.content}</Typography>
    </StyledLabel>
  );
};

export interface RadioGroupProps extends PropsWithChildren {
  direction?: 'row' | 'column';
  options: RadioOption[];
  name: string;
  onChange: (option: RadioOption) => void;
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  disabled?: boolean;
  'data-cy'?: string;
}

export const RadioGroup = ({
  direction = 'row',
  options,
  name,
  onChange,
  justifyContent = 'flex-start',
  'data-cy': dataCy,
  ...otherProps
}: RadioGroupProps) => {
  const GroupContainer = styled.div`
    display: flex;
    flex-direction: ${direction};
    justify-content: ${justifyContent};
    gap: var(--rk-spacing-xl);
  `;
  return (
    <GroupContainer role="radiogroup" data-cy={dataCy}>
      {options.map((option, idx) => (
        <Radio
          key={idx}
          name={name}
          option={option}
          checked={option.checked}
          onSelect={onChange}
          data-cy={option.dataCy ? `${dataCy}-option-${option.dataCy}` : `${dataCy}-option-${option.value}`}
          {...otherProps}
        />
      ))}
    </GroupContainer>
  );
};
